import React from 'react';
import Image from 'next/image';
import LazyLoad from 'react-lazyload';

const WithYou = ({children}) => {
    return (
        <section className="w-full bg-blue-stress text-white text-center">
            <div className="pt-6">
                <div className="pw">
                    <div className="w-full">
                        <div className="w-full">
                            <LazyLoad once>
                                <Image loading="lazy"
                                src='https://cdn.fixat.mx/assets/home/img/fixat-cuenta-con-nosotros.png'
                                alt="FIXAT®, cuenta con nosotros!" 
                                title="Fixat, cuenta con nosotros!"
                                height='200px'
                                width='438px'
                                />
                            </LazyLoad>
                        </div>
                        <div className="w-full">
                            <span className="font-fredoka text-1.5xl tracking-widest pt-3 mb-2 block">
                                Declaramos tus impuestos
                            </span>
                            <span className="font-fredoka text-3xl tracking-widest mb-8 block">
                                RÁPIDO, FÁCIL Y SEGURO
                            </span>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WithYou;
